import { Link } from 'react-router-dom';
import { useLanguage } from './i18n/LanguageContext';

function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="bg-white border-t border-gray-200 py-16">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-1">
            <div className="mb-6">
              <img src="/logo.png" alt="VentuNext" className="h-8" />
            </div>
            <p className="text-gray-500 text-sm leading-relaxed">
              {t.footer.tagline}
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-navy-primary mb-4">{t.footer.company}</h4>
            <div className="space-y-2">
              <a href="/#about" className="block text-gray-500 hover:text-blue-accent transition-colors text-sm">{t.footer.about}</a>
              <a href="/#vision" className="block text-gray-500 hover:text-blue-accent transition-colors text-sm">{t.footer.vision}</a>
            </div>
          </div>
          <div>
            <h4 className="font-semibold text-navy-primary mb-4">{t.footer.resources}</h4>
            <div className="space-y-2">
              <Link to="/team" className="block text-gray-500 hover:text-blue-accent transition-colors text-sm">{t.footer.ourTeam}</Link>
              <Link to="/career" className="block text-gray-500 hover:text-blue-accent transition-colors text-sm">{t.footer.careers}</Link>
              <Link to="/contact" className="block text-gray-500 hover:text-blue-accent transition-colors text-sm">{t.footer.contact}</Link>
            </div>
          </div>
          <div>
            <h4 className="font-semibold text-navy-primary mb-4">{t.footer.getInTouch}</h4>
            <p className="text-gray-500 text-sm mb-4">{t.footer.location}</p>
            <a href="mailto:info@ventunext.com" className="inline-flex items-center gap-2 text-blue-accent hover:text-navy-primary transition-colors text-sm">
              info@ventunext.com
            </a>
          </div>
        </div>
        <div className="pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-xs">&copy; {t.footer.rights}</p>
          <div className="flex gap-6">
            <span className="text-gray-400 hover:text-navy-primary transition-colors text-xs cursor-pointer">{t.footer.privacy}</span>
            <span className="text-gray-400 hover:text-navy-primary transition-colors text-xs cursor-pointer">{t.footer.terms}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
